import type { PriorAuthorizationInfoFragment } from '../../graphql/generated/graphql';
import type { BasicPrescriberOrderFragment } from '../cabinet/prescriber-orders';

export const isBasicPrescriberOrder = (
    order: BasicPrescriberOrderFragment | PriorAuthorizationInfoFragment
): order is BasicPrescriberOrderFragment => {
    return order.__typename !== 'PriorAuthorization';
};
